<template>
  <div>

    <!-- bg_stars -->
    <div class="ui-bg-stars">
    </div>

    <!-- banner -->
    <div class="ui-uni-banner">
      <div class="container ref">
        <div class="title-box">
          <h1>
            {{lg('',{
              en: 'Breed',
              zh: '繁殖',
            })}}
          </h1>
          <div>
            {{lg('',{
              en: 'Make new lions',
              zh: '选择自己的如意伴侣，开始创造可爱的小狮子吧',
            })}}
          </div>
        </div>

        <img 
          class="banner-img" 
          src="/static/img/bg_uni_banner_02.png?v=2" 
          style="height: 200px; right:10px; bottom: -18px;"
        >
      </div>
    </div>
    
    <!-- comingsoon -->
    <!-- <div style="margin: 100px 0;">
      <div class="ui-uni-comingsoon bg-pink">
        <h1>
          Coming soon
        </h1>
      </div>
    </div> -->

    <div class="container my-5">
      <div v-if="status_loading_list" class="text-muted text-center py-3">
        <span class="op5">Loading...</span>
      </div>
      <div v-else>
        <div class="sp-list-main">
          <div
            v-for="(item,index) of list_lion_breeding"
            :key="index"
            class="sp-item"
            >
            <lionItem
              :data="item"
              :cfg_show_breed_row="true"
              class="styled-2"
            />
          </div>
        </div>
        <div>
          <pagination
            mix_class="justify-content-center"
            :conf="pagination_cfg"
            @reloadList="listBreedingHorse()"
          />
        </div>
      </div>
    </div>

    <!-- ↓ hide -->
    <!-- <div v-if="0" class="container">

      <h4 class="my-4 op4">
        {{lg('',{
          en: 'Breeding',
          zh: '',
        })}}
      </h4>

      <div class="d-flex mb-1 op4 text-small mb-none">
        <span class="">
          STALLION
        </span>
        <span class="ml-auto text-center" style="width: 100px;">
          TIME LEFT
        </span>
        <span class="ml-3 text-center" style="width: 100px;">
          STUD FEE
        </span>
      </div>

      <div>
        <div v-for="(item,index) of list_lion_breeding" :key="index" class="mb-3">
          <horseItem 
            :data="item"
            :cfg_show_breed_row="true"
          />
        </div>
      </div>
    </div> -->


    <!-- <popupSelectMate/> -->
  </div>
</template>

<script>
import {mapActions} from 'vuex'
// import horseItem from '../_cp_busi/horse_item.vue'
import lionItem from '@/views/_cp_busi/lion_item.vue'
import pagination from '@/views/_cp_base/pagination.vue'

export default {
  name: 'breeding',
  components: {
    // horseItem,
    lionItem,
    pagination,
  },
  props: [],
  data() {
    return {
      list_lion_breeding: [],
      status_loading_list: false,
      pagination_cfg: {
        'page_size': 12, //每页条目数量
        'page_current': 1, // 当前页
        'count_items': null, //总个数，和总页数选填其一
        'btn_num': 10, // 按钮个数
        'turnpage_top': true, // 翻页时操作滚动置顶
        'count_pages': 27, //总页数，和个页数选填其一 // 默认请给 0 值-便于首次加载时不露出分页器
      },
    }
  },
  computed: {
    address_my(){
      return this.$store.state.web3.account
    },
  },
  watch: {
    address_my(val){
      if(val){
        this.listBreedingHorse()
      }
    },
  },
  methods: {
    ...mapActions([
      'getAuctionAllHorse',
    ]),

    async listBreedingHorse(){
      let v = this
      if(!v.address_my){
        return
      }
      v.status_loading_list = true
      const res = await v.getAuctionAllHorse({
        address_my: v.address_my,
        page: v.pagination_cfg.page_current,
        numPerPage: v.pagination_cfg.page_size,
      })
      // console.log('=====breeding horse res===',res)
      // console.log(res)

      let res_new = res.map(item => {
        return v.transHorseData(item)
      })

      v.list_lion_breeding = res_new
      v.status_loading_list = false
      // console.log('=====breeding horse res new===',res)
      // console.log(res)
    },
  },
  created() {
    this.listBreedingHorse()
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>